import React, { useEffect, useRef, useState } from "react";
import { Fragment } from "react";
import axios from "axios";
import { CRM_BASE_URL } from "../../app/crmApi";

const Terms = () => {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const scollToView = useRef(null);

  useEffect(() => {
    let active = true;
    axios
      .get(`${CRM_BASE_URL}policies/user/terms_conditions`)
      .then((res) => {
        if (active && res.data?.success) setPolicy(res.data.data);
      })
      .catch(() => {
        if (active) setPolicy(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    scollToView.current?.scrollIntoView({ behavior: "smooth" });
    return () => {
      active = false;
    };
  }, []);

  return (
    <Fragment>
      <section className="terms-and-condition" ref={scollToView}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="title text-center">
                {loading ? "Loading..." : policy?.title || "Terms & condition"}
              </h2>
            </div>
            <div className="col-lg-12">
              <div
                className="tc-text terms-and-condition-website"
                dangerouslySetInnerHTML={{ __html: policy?.content || "" }}
              ></div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Terms;
